import Authorizer from "../../components/Authorizer";
import EventsTable from "../../tables/EventsTable";
import IconLinkButton from "../../components/IconLinkButton";
import ViewContents from "../../components/ViewContents";
import ViewHeader from "../../components/ViewHeader";
import { PlusCircle } from "react-feather";
import { listEvents } from "../../clients/art";
import { usePersistentState } from "../../hooks/usePersistentState";

function Events() {
  const [params, setParams] = usePersistentState(
    {
      skip: 0,
      limit: 100,
    },
    "Events:params"
  );

  return (
    <>
      <ViewHeader
        breadcrumbs={["Events"]}
        actions={
          <Authorizer role="admin">
            <IconLinkButton
              to="/events/new"
              icon={PlusCircle}
              className="btn btn-success"
            >
              Create event
            </IconLinkButton>
          </Authorizer>
        }
      />
      <ViewContents>
        <EventsTable
          params={params}
          onParamsChange={setParams}
          request={listEvents}
          paginated={true}
        />
      </ViewContents>
    </>
  );
}

export default Events;
